import { User } from '@/api';
import { FCT } from '@/i18n';

export const calculateAge = (patient: User, hasPIIAccess: boolean): number | undefined => {
  const dob = hasPIIAccess ? patient?.dob : patient?.fake_dob;

  if (!dob) {
    return undefined;
  }

  const today = new Date();
  const dobDate = new Date(dob);
  let age = today.getFullYear() - dobDate.getFullYear();
  const monthDiff = today.getMonth() - dobDate.getMonth();
  const dayDiff = today.getDate() - dobDate.getDate();

  if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
    age--;
  }

  return age;
};

export const getPatientDisplayName = (patient: User, hasPIIAccess: boolean) => {
  if (hasPIIAccess && patient?.lastname && patient?.firstname) {
    return `${patient.lastname}, ${patient.firstname}`;
  }

  if (patient?.fake_lastname && patient?.fake_firstname) {
    return `${patient.fake_lastname}, ${patient.fake_firstname}`;
  }

  return FCT.REPORTING.HEADER.UNKNOWN.NAME;
};

export const getPatientDob = (patient: User, hasPIIAccess: boolean) => {
  if (hasPIIAccess && patient?.dob) {
    return `DOB: ${patient.dob}`;
  }

  return `Approx DOB: ${patient?.fake_dob}`;
};
